if (!customElements.get('image-text-collapsible')) {
  customElements.define(
    'image-text-collapsible',
    class ImageTextCollapsible extends HTMLElement {
      constructor() {
        super();
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
      }

      connectedCallback() {
        this.initializeComponent();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleAccordionClick);
      }

      initializeComponent() {
        this.addEventListener('click', this.handleAccordionClick);
      }

      handleAccordionClick(event) {
        const clickedTitle = event.target.closest('.image-text__collapsible-title');
        if (!clickedTitle) return;
        
        this.toggleAccordion(clickedTitle);
      }

      toggleAccordion(clickedTitle) {
        const targetAccordion = clickedTitle.closest('.image-text__collapsible');
        const accordionId = targetAccordion.dataset.id;
        
        // Close all accordions and hide all images
        this.closeAllAccordions();
        this.hideAllImages();
        
        // Open the clicked accordion and show its corresponding image
        targetAccordion.classList.add('open');
        this.showImage(accordionId);
      }

      closeAllAccordions() {
        const allAccordions = this.querySelectorAll('.image-text__collapsible');
        allAccordions.forEach(accordion => {
          accordion.classList.remove('open');
        });
      }

      hideAllImages() {
        const allImages = this.querySelectorAll('.image-with-text__image');
        allImages.forEach(image => {
          image.classList.remove('is-visible');
        });
      }

      showImage(imageId) {
        const targetImage = this.querySelector(`.image-with-text__image#${imageId}`);
        if (targetImage) {
          targetImage.classList.add('is-visible');
        }
      }
    }
  );
}

if (!customElements.get('timeline-circle')) {
  customElements.define(
    'timeline-circle',
    class TimelineCircle extends HTMLElement {
      constructor() {
        super();
        this.blocks = null;
        this.currentIndex = 0;
        this.intervalId = null;
        this.observer = null;
        this.isUserInteracted = false;
        this.interactionTimeout = null;
      }

      connectedCallback() {
        const options = {
          rootMargin: '0px 0px 400px 0px',
          threshold: 0.1
        };

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        if (this.interactionTimeout) {
          clearTimeout(this.interactionTimeout);
        }
        if (this.observer) {
          this.observer.disconnect();
        }
        // Remove event listeners
        this.removeAllClickListeners();
      }

      removeAllClickListeners() {
        if (this.blocks) {
          this.blocks.forEach(block => {
            block.removeEventListener('click', this.handleBlockClick);
          });
        }
      }

      handleIntersection(entries) {
        if (!entries[0].isIntersecting) {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
          return;
        }

        this.observer.unobserve(this);
        this.blocks = this.querySelectorAll('.timeline__circle-item');
        if (this.blocks.length === 0) return;

        // Add click event listeners to each block
        this.blocks.forEach((block, index) => {
          block.addEventListener('click', () => this.handleBlockClick(index));
        });

        this.updateTimeline();
        
        const delay = parseInt(this.getAttribute('data-delay')) || 5000;
        this.intervalId = setInterval(() => {
          if (!this.isUserInteracted) {
            this.currentIndex = (this.currentIndex + 1) % this.blocks.length;
            this.updateTimeline();
          }
        }, delay);
      }

      handleBlockClick(clickedIndex) {
        // Clear any existing interaction timeout
        if (this.interactionTimeout) {
          clearTimeout(this.interactionTimeout);
        }

        // Set user interaction flag
        this.isUserInteracted = true;
        
        // Update current index and timeline
        this.currentIndex = clickedIndex;
        this.updateTimeline();

        // Reset user interaction flag after a delay
        // This allows the auto-rotation to resume after user interaction
        const delay = parseInt(this.getAttribute('data-delay')) || 5000;
        this.interactionTimeout = setTimeout(() => {
          this.isUserInteracted = false;
        }, delay); // Resume auto-rotation
      }

      updateTimeline() {
        this.blocks.forEach(block => {
          block.classList.remove('active', 'next', 'next-next', 'prev');
        });
        
        const nextIndex = (this.currentIndex + 1) % this.blocks.length;
        const nextNextIndex = (this.currentIndex + 2) % this.blocks.length;
        const prevIndex = (this.currentIndex - 1 + this.blocks.length) % this.blocks.length;
        
        this.blocks[this.currentIndex].classList.add('active');
        this.blocks[nextIndex].classList.add('next');
        this.blocks[nextNextIndex].classList.add('next-next');
        this.blocks[prevIndex].classList.add('prev');
      }
    }
  )
}

if (document.querySelector('.multicolumn__carousel')) {
  const multicolumnSlider = new Flickity( '.multicolumn__carousel', {
    wrapAround: true,
    prevNextButtons: false,
    contain: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: false
  });
}